import React, { useEffect } from "react";

import PortalContadorOS from "../../components/PortalHome/Modal/OrdensDeServiço/PortalContadorOS";
import { useParams } from "react-router-dom";

function DetalheOS() {

    const { id } = useParams();

  return (
    <>
        <PortalContadorOS numeroSolicitacao={id}/>
    </>
  );
}
export default DetalheOS;
